import React from "react";
import { Link } from "react-router-dom";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { utcDateLabel } from "../../../utils/utcTime";

// Header explanation block that sits above the read-only past-snapshot in the Last
// Submitted Responses tab. Communicates that the *current* sponsor's request has not
// been accepted yet, and links to each past submission's Details page.
const LastSubmittedResponsesHeader = ({
  pastSubmissions,
  currentSponsorName,
  returnToId,
}) => {
  if (!pastSubmissions || pastSubmissions.length === 0) return null;

  // The Details route is keyed on the HC questionnaire_id (int).
  const buildLink = (questionnaireId) =>
    returnToId
      ? `/RFI/${questionnaireId}/Details?returnTo=${returnToId}`
      : `/RFI/${questionnaireId}/Details`;

  return (
    <div className="rounded-lg border border-indigo-100 bg-indigo-50/40 p-4 flex items-start gap-3">
      <InformationCircleIcon
        className="h-5 w-5 text-indigo-500 shrink-0 mt-0.5"
        aria-hidden="true"
      />
      <div className="flex-1 min-w-0 text-sm text-gray-800 leading-relaxed">
        <p>
          The request from{" "}
          <span className="font-semibold">{currentSponsorName || "this sponsor"}</span>{" "}
          has not been accepted yet. The responses below come from a previously
          completed submission of the same Diligent VQQ template:
        </p>
        <ul className="mt-2 space-y-1">
          {pastSubmissions.map((p) => (
            <li key={p.sponsor_rfi_response_id} className="text-sm">
              <Link
                to={buildLink(p.questionnaire_id)}
                className="text-indigo-700 underline font-medium hover:text-indigo-800"
              >
                {p.sponsor_name || "Sponsor"}
              </Link>{" "}
              <span className="text-gray-600">
                ·{" "}
                {utcDateLabel(p.release_date, "MMMM D, YYYY")}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default LastSubmittedResponsesHeader;
